/*' Wrote Huda,Shaher,Jacinta' */
import * as types from '../actions/actiontype'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as appConstants from './../../../overrides/appconstants'
//import * as quotationConstants from './../constants'
const initialState = {
}
initialState.checkPermissions = {
    /*User Search*/
    hasAddNewUser: false,
    hasResetUserSearch: false,
    hasUserSearch: false,


    hasViewUser: false,
    hasActiveDeactiveUser: false,
    hasUnlockUser: false,
    hasResetUserPassword: false,


    hasCopyUser: false,
    hasSaveUser: false,
    hasUserApplicableBranch: false,
    hasUserPartyCode: false,
    hasResetUser: false,


    hasAddUserBranch: false,
    hasRemoveUserBranch: false,
    hasResetUserBranch: false,
    hasSaveUserBranch: false,


    /*Group Search*/
    hasAddNewGroup: false,
    hasResetGroupSearch: false,
    hasSearchGroup: false,


    hasViewGroup: false,

    hasResetGroup: false,
    hasSaveGroup: false,
    hasGroupMenus: false,
    hasGroupReports: false,

    hasResetGroupMenus: false,
    hasSaveGroupMenus: false,
    hasResetGroupReports: false,
    hasSaveGroupReports: false,

    /*User Group*/
    hasAddUserGroup: false,
    hasRemoveUserGroup: false,
    hasResetUserGroup: false,
    hasSaveUserGroup: false,

    /*Password Profile*/
    hasResetPasswordProfile: false,
    hasSavePasswordProfile: false,
    hasViewPasswordProfile: false
}
initialState.masters = {
    statusMasters: [
        { minorCode: 0, statusName: null, moduleType: 0 }
    ],
    businessTypeMaster: [
        { domainValue: 0, domainValueName: null }
    ],
    stageMasters: [
        { stageStatusId: 0, stageName: null, majorCode: 0, moduleType: 0 }
    ],
    productMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    agentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    allAgentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    agentSearchMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    planMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ],
    searchPlanMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ],
    branchMasters: [
        { brCode: 0, brName: null }
    ],
    visaEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    documentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredVisaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    entityTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    maritalStatusMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    nationalityMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salutationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    collectionPointMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    typeMaster: [
        { id: 1, name: "Type-1" },
        { id: 2, name: "Type-2", }
    ],
    relationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salaryBandMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    idTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    dhaMemberTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    workEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    residentEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    workLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    residentLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    vatTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    chargesTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    transactionTypeMasters: [
        { domainValue: 1, domainValueName: "Convert Quotation to Endorsement" },
        { domainValue: 2, domainValueName: "Convert Quotation to Policy" },
        { domainValue: 3, domainValueName: "Revision Required" },
        { domainValue: 4, domainValueName: "Print Quotation Summary" },
        { domainValue: 5, domainValueName: "Refer to Underwriter" },
    ],
    principalMasters: [
        { principalId: 0, principalName: null }

    ],
    applyTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    visaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    regionMasters: [
        { regionId: 0, regionName: null, emirateId: 0, emirateName: null, }
    ],
    promoCodeMasters: [
        { promoId: 0, promoName: null }
    ],
    paymentModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    portalPlanTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    userGroupMasters: [
        { groupId: 0, groupName: null }
    ],
    departmentMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    companyMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    passwordProfileMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    userTypesMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    partyCodeMasters: [
        { accId: 0, partyCode: null, partyName: null, partyAccountType: null }
    ]

}


initialState.modalsState = {
    showApplicableModal: false,
    showGroupMenusModal: false,
    showGroupReportsModal: false,
    showUserGroupsModal: false,
    showPartyCodeModal: false
}

initialState.userSearch = {
    userId: null,
    userName: null,
    activeFrom: appUtility.getMinusOneYearToCurrentDate(),
    activeTo: appUtility.getCurrentDate(),
    sortString: null,
    sortStringDirection: 0,
    isSubmit: false,
    showSearchResult: false,
    searchResult: [],
    hasCheckedBoxInSearchResult: false,
    searchClass: "collapse show",
    searchResultClass: "collapse show",
}
initialState.userMaster = {
    userId: null,
    userName: null,
    password: null,
    retypePassword: null,
    employeeId: null,
    officePhone: null,
    extension: null,
    resPhone: null,
    fax: null,
    defaultCompany: null,
    defaultPrinterCode: null,
    macAddress: null,
    partyCode: null,
    passwordProfile: null,
    startMenu: null,
    managerId: null,
    userType: null,
    shiftCode: null,
    multiMachineLoginYN: null,
    forcedPasswordYN: null,
    passwordExpiryYN: null,
    lockYN: null,
    expiryDate: null,
    designation: null,
    userGroup: [],
    mobileNo: null,
    email: null,
    defaultDivision: null,
    defaultDepartment: null,
    userActiveYN: null,
    action: null,
    currentUserId: null,
    showCurrentUserMaster: false,
    signatureFile: null,
    signatureFileName: null,
    premiumAccount: null,
    commissionAccount: null,
    deactivationDate:null
}
initialState.applicableBranches = {
    branchMasters: [
        { brCode: 0, brName: null }
    ],
    userBranches: []
}

initialState.userGroupSearch = {
    userGroupCode: null,
    userGroupName: null,
    department: null,
    sortString: null,
    sortStringDirection: 0,
    isSubmit: false,
    showSearchResult: false,
    searchResult: [],
    hasCheckedBoxInSearchResult: false,
    searchClass: "collapse show",
    searchResultClass: "collapse show",
}

initialState.userGroupCreate = {
    groupId: null,
    userGroupCode: null,
    userGroupName: null,
    remarks: null,
    department: null,
    showCurrentUserGroup: false,
    showUserGroup: false,
    currentGroupId: null
}

initialState.groupMenus = {
    menuId: null,
    menuType: null,
    menuParentId: null,
    menuName: null,
    moduleCode: null,
    menuIconYn: null,
    menuPageCode: null,
    menuFont: null,
    menuCreatedBy: null,
    menuToolTip: null,
    menuHelp: null,
    menuShortCutKey: null,
    updatedBy: null,
    menuCreatedDt: null,
    updatedDt: null,
    menuDisplayName: null,
    menuUrl: null,
    sequenceNo: null,

    groupId: null,
    companyId: null,
    gorupCode: null,
    groupName: null,
    groupCreatedBy: null,
    groupUpdatedBy: null,
    groupCreatedDt: null,
    groupUpdatedDt: null,

    grpMenuId: null,
    grpMenuGroupId: null,
    grpMenuIsActive: null,
    grpMenuMenuId: null,
    grpMenuVisibleYn: null,
    grpMenuModuleId: null,
    createdBy: null,
    createdDt: null,
    groupMenuUpdatedBy: null,
    groupMenuUpdatedDt: null,

    secModuleCode: null,
    secModuleName: null,
    secModuleSystemId: null,
    secModuleId: null,
    moduleCreatedBy: null,
    moduleUpdatedBy: null,
    moduleCreatedDt: null,
    moduleUpdatedDt: null,

    usrCompanyId: null,
    usrId: null,
    usrBrBranchId: null,
    usrBrIsDefault: null,
    usrBrIsActive: null,
    usrBrActiveFromDt: null,
    usrBrActiveToDt: null,
    usrBrCreatedBy: null,
    usrBrUpdatedBy: null,
    usrBrCreatedDt: null,
    usrBrUpdatedDt: null,

    searchResult: [],
}

initialState.assignGroupMenus = {
    groupId: null,
    systemMenus: [],
    selectGroupMenus: []

}
initialState.assignGroupReports = {
    systemReports: []

}

initialState.passwordProfile = {
    passwordProfileId: null,
    profileName: null,
    specialCharNotAllowed: null,
    minimumLength: null,
    maximumLength: null,
    passwordAgeInDays: null,
    remainderDaysBeforeExp: null,
    passwordHistory: null,
    loginFailCount: null,
    matchCharCount: null,
    passwordResetYN: null,
    splCharMandatoryYN: null,
    atLeastOneUpperCase: null,
    atLeastOneLowerCase: null,
    atLeastOneNumber: null,
    matchCharAtSamePosition: null,
    matchCharAtAnyPosition: null,
    resetFailCountOnLogin: null,
    resetFailCountDaily: null,
    captchaRequired: null,
    logonBannerYN: null,
    searchResult: [],
    searchClass: "collapse show",

}

initialState.passwordProfileListing = {
    passwordProfileId: null,
    profileName: null,
    specialCharNotAllowed: null,
    passwordAgeInDays: null,
    minimumLength: null,
    maximumLength: null,
    passwordAgeInDays: null,
    remainderDaysBeforeExp: null,
    passwordHistory: null,
    loginFailCount: null,
    matchCharCount: null,
    passwordResetYN: null,
    splCharMandatoryYN: null,
    atLeastOneUpperCase: null,
    atLeastOneLowerCase: null,
    atLeastOneNumber: null,
    matchCharAtSamePosition: null,
    matchCharAtAnyPosition: null,
    resetFailCountOnLogin: null,
    resetFailCountDaily: null,
    captchaRequired: null,
    logonBannerYN: null,
    searchResult: [],
    searchClass: "collapse show",
    sortString: null,
    showSearchResult: false,
}

initialState.groupMenus = {
    menuId: null,
    menuType: null,
    menuParentId: null,
    menuName: null,
    moduleCode: null,
    menuIconYn: null,
    menuPageCode: null,
    menuFont: null,
    menuCreatedBy: null,
    menuToolTip: null,
    menuHelp: null,
    menuShortCutKey: null,
    updatedBy: null,
    menuCreatedDt: null,
    updatedDt: null,
    menuDisplayName: null,
    menuUrl: null,
    sequenceNo: null,

    groupId: null,
    companyId: null,
    gorupCode: null,
    groupName: null,
    groupCreatedBy: null,
    groupUpdatedBy: null,
    groupCreatedDt: null,
    groupUpdatedDt: null,

    grpMenuId: null,
    grpMenuGroupId: null,
    grpMenuIsActive: null,
    grpMenuMenuId: null,
    grpMenuVisibleYn: null,
    grpMenuModuleId: null,
    createdBy: null,
    createdDt: null,
    groupMenuUpdatedBy: null,
    groupMenuUpdatedDt: null,

    secModuleCode: null,
    secModuleName: null,
    secModuleSystemId: null,
    secModuleId: null,
    moduleCreatedBy: null,
    moduleUpdatedBy: null,
    moduleCreatedDt: null,
    moduleUpdatedDt: null,

    usrCompanyId: null,
    usrId: null,
    usrBrBranchId: null,
    usrBrIsDefault: null,
    usrBrIsActive: null,
    usrBrActiveFromDt: null,
    usrBrActiveToDt: null,
    usrBrCreatedBy: null,
    usrBrUpdatedBy: null,
    usrBrCreatedDt: null,
    usrBrUpdatedDt: null,

    searchResult: [],
}



initialState.menusListing = {
    menuId: null,
    menuType: null,
    menuParentId: null,
    menuName: null,
    moduleCode: null,
    menuIconYn: null,
    menuPageCode: null,
    menuFont: null,
    menuCreatedBy: null,
    menuToolTip: null,
    menuHelp: null,
    menuShortCutKey: null,
    updatedBy: null,
    menuCreatedDt: null,
    updatedDt: null,
    menuDisplayName: null,
    menuUrl: null,
    sequenceNo: null,
    searchResult: [],
    searchClass: "collapse show",
}

initialState.groupsListing = {
    groupId: null,
    companyId: null,
    gorupCode: null,
    groupName: null,
    groupCreatedBy: null,
    groupUpdatedBy: null,
    groupCreatedDt: null,
    groupUpdatedDt: null,
    searchResult: [],
    searchClass: "collapse show",
}
initialState.groupmenusListing = {
    grpMenuId: null,
    grpMenuGroupId: null,
    grpMenuIsActive: null,
    grpMenuMenuId: null,
    grpMenuVisibleYn: null,
    grpMenuModuleId: null,
    createdBy: null,
    createdDt: null,
    groupMenuUpdatedBy: null,
    groupMenuUpdatedDt: null,
    searchResult: [],
    searchClass: "collapse show",

}
initialState.modulesListing = {
    secModuleCode: null,
    secModuleName: null,
    secModuleSystemId: null,
    secModuleId: null,
    moduleCreatedBy: null,
    moduleUpdatedBy: null,
    moduleCreatedDt: null,
    moduleUpdatedDt: null,
    searchResult: [],
    searchClass: "collapse show",
}
initialState.userBranchesListing = {
    usrCompanyId: null,
    usrId: null,
    usrBrBranchId: null,
    usrBrIsDefault: null,
    usrBrIsActive: null,
    usrBrActiveFromDt: null,
    usrBrActiveToDt: null,
    usrBrCreatedBy: null,
    usrBrUpdatedBy: null,
    usrBrCreatedDt: null,
    usrBrUpdatedDt: null,
    searchResult: [],
    searchClass: "collapse show",
}


initialState.assignUserGroups = {
    userId: null,
    userName: null,
    activeFrom: appUtility.getMinusOneYearToCurrentDate(),
    activeTo: appUtility.getCurrentDate(),
    sortString: null,
    sortStringDirection: 0,
    isSubmit: false,
    showSearchResult: false,
    searchResult: [],
    hasCheckedBoxInSearchResult: false,
    searchClass: "collapse show",
    searchResultClass: "collapse show",
}

initialState.userGroups = {
    userId: null,
    groupsMasters: [
        { groupId: 0, groupName: null }
    ],
    userGroups: []
}


export default function secmasterReducer(state = initialState, action) {
    switch (action.type) {

        case types.UPDATE_SECURITY_MODULE_PERMISSIONS:
            return {
                ...state,
                checkPermissions: {
                    ...state.checkPermissions,
                    ...action.payload
                }

            }
        case types.GET_INSURED_INFORMATION_MASTERS_END:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    userTypesMasters: action.result.userTypesMasters,
                    departmentMasters: action.result.departmentMaster
                }
            }
        case types.GET_SECURITY_MASTERS_END:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    userGroupMasters: action.result.userGroupMasters,
                    companyMasters: action.result.companyMasters,
                    branchMasters: action.result.branchMasters,
                    passwordProfileMasters: action.result.passwordProfileMasters,
                    partyCodeMasters: action.result.partyCodeMasters
                },
                applicableBranches: {
                    ...state.applicableBranches,
                    branchMasters: action.result.branchMasters
                },
                userGroups: {
                    ...state.userGroups,
                    groupsMasters: action.result.userGroupMasters
                }
            }
        case types.UPDATE_PASSWORD_PROFILE_PROFILE:
            return {
                ...state,
                passwordProfile: {
                    ...state.passwordProfile,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.GET_ALL_PASSWORD_PROFILE_PROFILE_END:
            return {
                ...state,
                passwordProfileListing: {
                    ...state.passwordProfileListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload,

                }
            }

        case types.GET_ALL_PASSWORD_PROFILE_BY_PROFILE_ID_END:
            return {
                ...state,
                passwordProfile: {
                    ...state.passwordProfile,
                    passwordProfileId: action.payload.passwordProfileId == null ? "" : action.payload.passwordProfileId,
                    profileName: action.payload.profileName,
                    specialCharNotAllowed: action.payload.specialCharNotAllowed,
                    passwordAgeInDays: action.payload.passwordAge,
                    minimumLength: action.payload.minimumLength,
                    maximumLength: action.payload.maximumLength,
                    remainderDaysBeforeExp: action.payload.remainderDaysBeforeExpiry,
                    passwordHistory: action.payload.passwordHistory,
                    loginFailCount: action.payload.loginFailCount,
                    matchCharCount: action.payload.matchCharCount,
                    passwordResetYN: action.payload.resetPasswordYn == 'Y' ? true : false,
                    splCharMandatoryYN: action.payload.splCharMandatoryYn == 'Y' ? true : false,
                    atLeastOneUpperCase: action.payload.oneUpperCaseYn == 'Y' ? true : false,
                    atLeastOneLowerCase: action.payload.oneLowerCaseYn == 'Y' ? true : false,
                    atLeastOneNumber: action.payload.oneNumberYn == 'Y' ? true : false,
                    matchCharAtSamePosition: action.payload.matchCharSamePositionYn == 'Y' ? true : false,
                    matchCharAtAnyPosition: action.payload.matchCharAtAnyPostYn == 'Y' ? true : false,
                    resetFailCountOnLogin: action.payload.resetFailCount == 'Y' ? true : false,
                    resetFailCountDaily: action.payload.dailyResetFailCount == 'Y' ? true : false,
                    captchaRequired: action.payload.captchaYn == 'Y' ? true : false,
                    logonBannerYN: action.payload.logonBannerYn == 'Y' ? true : false,
                    //searchResult: action.payload.result,

                }
            }
        case types.CLEAR_PASSWORD_PROFILE_PARAMS:
            return {
                ...state,
                passwordProfile: {
                    ...state.passwordProfile,
                    passwordProfileId: null,
                    profileName: null,
                    specialCharNotAllowed: null,
                    minimumLength: null,
                    maximumLength: null,
                    passwordAgeInDays: null,
                    remainderDaysBeforeExp: null,
                    passwordHistory: null,
                    loginFailCount: null,
                    matchCharCount: null,
                    passwordResetYN: null,
                    splCharMandatoryYN: null,
                    atLeastOneUpperCase: null,
                    atLeastOneLowerCase: null,
                    atLeastOneNumber: null,
                    matchCharAtSamePosition: null,
                    matchCharAtAnyPosition: null,
                    resetFailCountOnLogin: null,
                    resetFailCountDaily: null,
                    captchaRequired: null,
                    logonBannerYN: null,
                    searchResult: [],
                    searchClass: "collapse show",
                }
            }

        case types.GET_ALL_MENUS_END:
            return {
                ...state,
                menusListing: {
                    ...state.menusListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload.result,

                }
            }

        case types.GET_ALL_GROUPS_END:
            return {
                ...state,
                groupsListing: {
                    ...state.groupsListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload.result,

                }
            }

        case types.GET_ALL_GROUP_MENUS_END:
            return {
                ...state,
                groupmenusListing: {
                    ...state.groupmenusListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload.result,

                }
            }

        case types.GET_ALL_MODULES_END:
            return {
                ...state,
                modulesListing: {
                    ...state.modulesListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload.result,

                }
            }

        case types.GET_ALL_USER_BRANCHES_END:
            return {
                ...state,
                userBranchesListing: {
                    ...state.userBranchesListing,
                    // planMasters: action.result.planTypeMasters,
                    searchResult: action.payload.result,

                }
            }

        case types.CLEAR_GROUP_MENU_PARAMS:
            return {
                ...state,
                groupMenus: {
                    ...state.groupMenus,
                    menuId: null,
                    menuType: null,
                    menuParentId: null,
                    menuName: null,
                    moduleCode: null,
                    menuIconYn: null,
                    menuPageCode: null,
                    menuFont: null,
                    menuCreatedBy: null,
                    menuToolTip: null,
                    menuHelp: null,
                    menuShortCutKey: null,
                    updatedBy: null,
                    menuCreatedDt: null,
                    updatedDt: null,
                    menuDisplayName: null,
                    menuUrl: null,
                    sequenceNo: null,

                    groupId: null,
                    companyId: null,
                    gorupCode: null,
                    groupName: null,
                    groupCreatedBy: null,
                    groupUpdatedBy: null,
                    groupCreatedDt: null,
                    groupUpdatedDt: null,

                    grpMenuId: null,
                    grpMenuGroupId: null,
                    grpMenuIsActive: null,
                    grpMenuMenuId: null,
                    grpMenuVisibleYn: null,
                    grpMenuModuleId: null,
                    createdBy: null,
                    createdDt: null,
                    groupMenuUpdatedBy: null,
                    groupMenuUpdatedDt: null,

                    secModuleCode: null,
                    secModuleName: null,
                    secModuleSystemId: null,
                    secModuleId: null,
                    moduleCreatedBy: null,
                    moduleUpdatedBy: null,
                    moduleCreatedDt: null,
                    moduleUpdatedDt: null,

                    usrCompanyId: null,
                    usrId: null,
                    usrBrBranchId: null,
                    usrBrIsDefault: null,
                    usrBrIsActive: null,
                    usrBrActiveFromDt: null,
                    usrBrActiveToDt: null,
                    usrBrCreatedBy: null,
                    usrBrUpdatedBy: null,
                    usrBrCreatedDt: null,
                    usrBrUpdatedDt: null,


                    searchResult: [],
                    searchClass: "collapse show",
                }
            }
        case types.UPDATE_USER_SEARCH_RESULT:
            let hasCheckedBoxInSearchResult = false
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    searchResult: action.pagedResult,
                    hasCheckedBoxInSearchResult: hasCheckedBoxInSearchResult
                }
            }
        case types.SHOW_USER_SEARCH_RESULTS:
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    isSubmit: true
                }
            }
        case types.SHOW_USER_TABLE_SEARCH_RESULTS:
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    showSearchResult: action.payload
                }
            }
        case types.UPDATE_USER_SORT_PARAMETER:
            let sortStringDirection = state.userSearch.sortStringDirection
            let sortString = action.payload.status
            if (sortStringDirection == 0) {
                sortStringDirection = 1
                sortString = sortString + " ASC"
            }
            else if (sortStringDirection == 1) {
                sortStringDirection = 2
                sortString = sortString + " DESC"
            }
            else if (sortStringDirection == 2) {
                sortStringDirection = 0
                sortString = "UserId ASC"
            }
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    sortString: sortString,
                    sortStringDirection: sortStringDirection,
                }
            }
        case types.UPDATE_CURRENT_USER_ID:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    currentUserId: action.payload.userId
                }
            }
        case types.SHOW_USER_MASTER:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    showUserMaster: action.payload.data
                }
            }
        case types.SHOW_CURRENT_USER_MASTER:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    showCurrentUserMaster: action.payload
                }
            }
        case types.GET_USER_MASTER_END:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    userId: action.payload.userId,
                    userName: action.payload.userName,
                    designation: action.payload.designation,
                    email: action.payload.email,
                    mobileNo: action.payload.mobileNo,
                    fax: action.payload.fax,
                    officePhone: action.payload.officePhone,
                    resPhone: action.payload.resPhone,
                    extension: action.payload.extension,
                    forcedPasswordYN: action.payload.forcedPasswordYN,
                    lockYN: action.payload.lockYN,
                    multiMachineLoginYN: action.payload.multiMachineLogInYN,
                    passwordExpiryYN: action.payload.passwordExpiryYN,
                    userActiveYN: action.payload.userActiveYN,
                    expiryDate: action.payload.expiryDate == null ? null : appUtility.formatDate(action.payload.expiryDate),
                    defaultCompany: action.payload.defaultCompany,
                    userGroup: action.payload.userGroup,
                    defaultDepartment: action.payload.defaultDepartment,
                    defaultDivision: action.payload.defaultDivision,
                    defaultPrinterCode: action.payload.defaultPrinterCode,
                    passwordProfile: action.payload.passwordProfile,
                    employeeId: action.payload.employeeId,
                    officePhone: action.payload.officePhone,
                    resPhone: action.payload.resPhone,
                    mobileNo: action.payload.mobileNo,
                    fax: action.payload.fax,
                    userType: action.payload.userType,
                    premiumAccount: action.payload.premiumAccount == null ? "" : action.payload.premiumAccount,
                    commissionAccount: action.payload.commissionAccount == null ? "" : action.payload.commissionAccount,
                    deactivationDate: action.payload.deactivationDate == null ? null : appUtility.formatDate(action.payload.deactivationDate),
                }
            }

        case types.COLLAPSE_USER_SEARCH_RESULT:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    searchResultClass: collapseClass
                }
            }
        case types.COLLAPSE_USER_SEARCH:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    searchClass: collapseClass
                }
            }
        case types.CLEAR_USER_SEARCH_PARAMS:
            return {
                ...state,
                userSearch: initialState.userSearch,
                userMaster: initialState.userMaster
            }

        case types.UPDATE_USER_SEARCH_PARAMS:
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.UPDATE_USER_SEARCH_CHECKBOX_PARAMS:
            return {
                ...state,
                userSearch: {
                    ...state.userSearch,
                    [action.payload.name]: action.payload.checked
                }
            }
        case types.CLEAR_USER_MASTER_INFORMATION:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    userId: null,
                    userName: null,
                    password: null,
                    retypePassword: null,
                    employeeId: null,
                    officePhone: null,
                    extension: null,
                    resPhone: null,
                    fax: null,
                    defaultCompany: null,
                    defaultPrinterCode: null,
                    macAddress: null,
                    partyCode: null,
                    passwordProfile: null,
                    startMenu: null,
                    managerId: null,
                    userType: null,
                    shiftCode: null,
                    multiMachineLoginYN: null,
                    forcedPasswordYN: null,
                    passwordExpiryYN: null,
                    lockYN: null,
                    expiryDate: null,
                    designation: null,
                    userGroup: null,
                    mobileNo: null,
                    email: null,
                    defaultDivision: null,
                    defaultDepartment: null,
                    userActiveYN: null,
                    action: null,
                    currentUserId: null,
                    signatureFile: null,
                    signatureFileName: null,
                    premiumAccount: null,
                    commissionAccount: null,
                    deactivationDate: null,
                },
                modalsState: {
                    ...state.modalsState,
                    showApplicableModal: false
                }
            }

        case types.UPDATE_USER_MASTER_PARAMS:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.UPDATE_USER_MASTER_CHECKBOX_PARAMS:
            return {
                ...state,
                userMaster: {
                    ...state.userMaster,
                    [action.payload.name]: action.payload.checked
                }
            }


        //User Group Page

        case types.CLEAR_USER_GROUP_SEARCH_PARAMS:
            return {
                ...state,
                userGroupSearch: initialState.userGroupSearch,
                userGroupCreate: initialState.userGroupCreate,
                assignGroupMenus: initialState.assignGroupMenus,
                assignGroupReports: initialState.assignGroupReports,
                modalsState: {
                    ...state.modalsState,
                    showGroupMenusModal: false,
                    showGroupReportsModal: false,
                }
                //userGroupInfo: initialState.userMaster
            }

        case types.COLLAPSE_USER_GROUP_SEARCH_RESULT:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    searchResultClass: collapseClass
                }
            }
        case types.COLLAPSE_USER_GROUP_SEARCH:
            var collapseClass = null
            if (action.payload == true) {
                collapseClass = "collapse"
            }
            else {
                collapseClass = "collapse show"
            }
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    searchClass: collapseClass
                }
            }
        case types.HANDLE_APPLICABLE_BRANCHES_RADIO_BTN_CHANGE: {
            let { brCode, value } = action.payload;
            // reset toggle value
            const updatedBranches = state.applicableBranches.branchMasters/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedBranch = updatedBranches.map((branch) => {
                if (branch.brCode == brCode) {
                    return { ...branch, isChecked: value };
                }
                return branch;
            });

            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    branchMasters: updatedBranch
                }
            };
        }
        case types.RESET_APPLICABLE_BRANCHES: {
            // reset toggle value
            const updatedBranches = state.applicableBranches.branchMasters/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedBranch = updatedBranches.map((branch) => {
                return { ...branch, isChecked: false };
            });

            const updatedUserBranches = state.applicableBranches.userBranches.map((branch) => {
                return { ...branch, isChecked: false };
            });

            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    branchMasters: updatedBranch,
                    userBranches: updatedUserBranches
                }
            };
        }
        case types.MOVE_TO_USER_BRANCHES: {
            // reset toggle value
            const branchesToMove = state.applicableBranches.branchMasters.filter((branch) =>
                branch.isChecked == true
            );
            // update current toggle value
            const updatedBranch = branchesToMove.map((branch) => {
                return { ...branch, isChecked: false };
            });
            const updatedMasterBranch = state.applicableBranches.branchMasters.map((branch) => {
                return { ...branch, isChecked: false };
            });
            const updatedUserBranch = state.applicableBranches.userBranches.concat(updatedBranch);

            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    branchMasters: updatedMasterBranch,
                    userBranches: updatedUserBranch?.filter(p => p?.brCode != 0)
                }
            };
        }
        case types.REMOVE_FROM_USER_BRANCHES: {
            // reset toggle value
            const brancheCodeToRemove = state.applicableBranches.userBranches.filter((branch) =>
                branch.isChecked == false
            );
            const branchesToRemove = state.applicableBranches.branchMasters.map((branch) => {
                if (brancheCodeToRemove.includes(branch.brCode)) {
                    return { ...branch, isChecked: false };
                }
                return branch;
            })
            // update current toggle value
            /* const updatedBranch = branchesToMove.map((branch) => {
                return { ...branch, isChecked: false };
            }); */

            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    userBranches: brancheCodeToRemove
                }
            };
        }
        case types.HANDLE_USER_BRANCHES_RADIO_BTN_CHANGE: {
            let { brCode, value } = action.payload;
            // reset toggle value
            const updatedBranches = state.applicableBranches.userBranches/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedBranch = updatedBranches.map((branch) => {
                if (branch.brCode == brCode) {
                    return { ...branch, isChecked: value };
                }
                return branch;
            });

            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    userBranches: updatedBranch
                }
            };
        }
        case types.UPDATE_MODAL_STATE_PARAMS: {
            return {
                ...state,
                modalsState: {
                    ...state.modalsState,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.GET_USER_APPLICABLE_RBANCHES_END: {
            return {
                ...state,
                applicableBranches: {
                    ...state.applicableBranches,
                    userBranches: action.payload.result
                }
            }
        }

        //UserGroup Search

        case types.UPDATE_USER_GROUP_SEARCH_PARAMS:
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.UPDATE_USER_GROUP_SEARCH_RESULT:
            let hasCheckedBoxInUserGroupSearchResult = false
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    searchResult: action.pagedResult,
                    hasCheckedBoxInSearchResult: hasCheckedBoxInUserGroupSearchResult
                }
            }
        case types.SHOW_USER_GROUP_SEARCH_RESULTS:
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    isSubmit: true
                }
            }
        case types.SHOW_USER_GROUP_TABLE_SEARCH_RESULTS:
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    showSearchResult: action.payload
                }
            }

        case types.UPDATE_USER_GROUP_SORT_PARAMETER:
            let groupSortStringDirection = state.userGroupSearch.sortStringDirection
            let groupSortString = action.payload.status
            if (groupSortStringDirection == 0) {
                groupSortStringDirection = 1
                groupSortString = groupSortString + " ASC"
            }
            else if (groupSortStringDirection == 1) {
                groupSortStringDirection = 2
                groupSortString = groupSortString + " DESC"
            }
            else if (groupSortStringDirection == 2) {
                groupSortStringDirection = 0
                groupSortString = "UserGroupCode ASC"
            }
            return {
                ...state,
                userGroupSearch: {
                    ...state.userGroupSearch,
                    sortString: groupSortString,
                    sortStringDirection: groupSortStringDirection,
                }
            }

        case types.SHOW_USER_GROUP:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    showUserGroup: action.payload.data
                }
            }
        case types.SHOW_CURRENT_USER_GROUP:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    showCurrentUserGroup: action.payload
                }
            }
        case types.UPDATE_CURRENT_GROUP_ID:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    currentGroupId: action.payload.groupId
                }
            }

        case types.GET_GROUP_INFO_END:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    groupId: action.payload.groupId,
                    userGroupCode: action.payload.userGroupCode,
                    userGroupName: action.payload.userGroupName,
                    remarks: action.payload.remarks,
                    department: action.payload.department
                }
            }
        case types.CLEAR_USER_GROUP_INFORMATION:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    groupId: null,
                    userGroupCode: null,
                    userGroupName: null,
                    remarks: null,
                    designation: null,
                    showUserGroup: true
                },
                assignGroupMenus: initialState.assignGroupMenus,
                assignGroupReports: initialState.assignGroupReports,
                modalsState: {
                    ...state.modalsState,
                    showGroupMenusModal: false,
                    showGroupReportsModal: false

                }
            }

        case types.UPDATE_USER_GROUP_CREATION_PARAMS:
            return {
                ...state,
                userGroupCreate: {
                    ...state.userGroupCreate,
                    [action.payload.name]: action.payload.value
                }
            }


        case types.GET_SYSTEM_MENUS_END:
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: action.payload.result
                }
            }
        case types.RESET_ASSIGN_GROUP_MENUS: {
            /* // reset toggle value
            const updatedMenus = state.assignGroupMenus.systemMenus/*.map((branch) => {
                    return { ...branch, isChecked: false };
                });
            const childMenus = state.assignGroupMenus.systemMenus.map(m => m.childMenus);
            const updateChildMenus = childMenus.map((cm) => {
                    return { ...cm, isChecked: false };

            });
            // update current toggle value
            const updatedMenu = updateChildMenus.map((menu) => {
                return { ...menu, isChecked: false };

            });

            /* const updatedSelectedBranches = state.assignGroupMenus.userBranches.map((menu) => {
                return { ...menu, isChecked: false };
            });  */
            const updatedMenus = state.assignGroupMenus.systemMenus
            for (let m in updatedMenus) {
                for (let c in updatedMenus[m].childMenus) {
                    for (let s in updatedMenus[m].childMenus[c].childMenus) {
                        for (let a in updatedMenus[m].childMenus[c].childMenus[s].childMenus) {
                            updatedMenus[m].childMenus[c].childMenus[s].childMenus[a].isChecked = false;
                        }
                        updatedMenus[m].childMenus[c].childMenus[s].isChecked = false;
                    }
                    updatedMenus[m].childMenus[c].isChecked = false;
                }
                updatedMenus[m].isChecked = false;
            }
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: updatedMenus
                }
            };
        }

        case types.HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_END: {
            let { menuId, value } = action.payload;
            const updatedMenus = state.assignGroupMenus.systemMenus
            for (let m in updatedMenus) {
                for (let c in updatedMenus[m].childMenus) {
                    for (let s in updatedMenus[m].childMenus[c].childMenus) {
                        for (let a in updatedMenus[m].childMenus[c].childMenus[s].childMenus) {
                            if (updatedMenus[m].childMenus[c].childMenus[s].childMenus[a].menuId == menuId) {
                                updatedMenus[m].childMenus[c].childMenus[s].childMenus[a].isChecked = value;
                            }
                        }
                    }
                    /* if (updatedMenus[m].childMenus[c].menuId == menuId) {
                        updatedMenus[m].childMenus[c].isChecked = value;
                    } */
                }
                /* if (updatedMenus[m].menuId == menuId) {
                    updatedMenus[m].isChecked = value;
                } */
            }
            // reset toggle value
            /*const updatedMenus = state.assignGroupMenus.systemMenus/*.map((branch) => {
                    return { ...branch, isChecked: false };
                });
            // update current toggle value
            const updatedMenu = updatedMenus.map((parentMenus) => {
                if (parentMenus.menuId == menuId) {
                    return {
                        ...parentMenus,
                        isChecked: value
                    };
                }
                else {
                    parentMenus.childMenus.map((child1Menu) => {
                        if (child1Menu.menuId == menuId) {
                            console.log({ ...child1Menu, isChecked: value })
                            return {
                                ...child1Menu,
                                isChecked: value
                            }
                        }
                        return child1Menu;
                    });

                }
                return parentMenus;
            }); */
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: updatedMenus
                }
            };
        }
        case types.HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_FOR_SUBCHILD_END: {
            let { menuId, value } = action.payload;
            const updatedMenus = state.assignGroupMenus.systemMenus
            for (let m in updatedMenus) {
                for (let c in updatedMenus[m].childMenus) {
                    for (let s in updatedMenus[m].childMenus[c].childMenus) {
                        if (updatedMenus[m].childMenus[c].childMenus[s].menuId == menuId) {
                            updatedMenus[m].childMenus[c].childMenus[s].isChecked = value;
                            for (let a in updatedMenus[m].childMenus[c].childMenus[s].childMenus) {
                                updatedMenus[m].childMenus[c].childMenus[s].childMenus[a].isChecked = value;
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: updatedMenus
                }
            };
        }
        case types.TOGGLE_MENU_OPEN: {
            let { menuId } = action.payload;
            const updatedMenus = state.assignGroupMenus.systemMenus
            for (let m in updatedMenus) {
                for (let c in updatedMenus[m].childMenus) {
                    for (let s in updatedMenus[m].childMenus[c].childMenus) {
                        if (updatedMenus[m].childMenus[c].childMenus[s].menuId == menuId) {
                            updatedMenus[m].childMenus[c].childMenus[s].showChild = updatedMenus[m].childMenus[c].childMenus[s].showChild ? false : true;
                        }
                    }
                    if (updatedMenus[m].childMenus[c].menuId == menuId) {
                        updatedMenus[m].childMenus[c].showChild = updatedMenus[m].childMenus[c].showChild ? false : true;
                    }
                } if (updatedMenus[m].menuId == menuId) {
                    updatedMenus[m].showChild = updatedMenus[m].showChild ? false : true;
                }
            }
            // reset toggle value
            /*const updatedMenus = state.assignGroupMenus.systemMenus/*.map((branch) => {
                    return { ...branch, isChecked: false };
                });
            // update current toggle value
            const updatedMenu = updatedMenus.map((parentMenus) => {
                if (parentMenus.menuId == menuId) {
                    return {
                        ...parentMenus,
                        isChecked: value
                    };
                }
                else {
                    parentMenus.childMenus.map((child1Menu) => {
                        if (child1Menu.menuId == menuId) {
                            console.log({ ...child1Menu, isChecked: value })
                            return {
                                ...child1Menu,
                                isChecked: value
                            }
                        }
                        return child1Menu;
                    });

                }
                return parentMenus;
            }); */
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: updatedMenus
                }
            };
        }

        case types.SHOW_PASSWORD_LISTING_TABLE_SEARCH_RESULTS:
            return {
                ...state,
                passwordProfileListing: {
                    ...state.passwordProfileListing,
                    showSearchResult: action.payload
                }
            }

        /*Assign User Group Page*/
        case types.CLEAR_ASSIGN_USER_GROUP_SEARCH:
            return {
                ...state,
                assignUserGroups: initialState.assignUserGroups,
                userSearch: initialState.userSearch,
                modalsState: {
                    ...state.modalsState,
                    showUserGroupsModal: false
                }
                //userGroupInfo: initialState.userMaster
            }
        case types.UPDATE_ASSIGN_USER_GROUP_SEARCH_PARAMS:
            return {
                ...state,
                assignUserGroups: {
                    ...state.assignUserGroups,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.UPDATE_ASSIGN_USER_GROUP_SEARCH_RESULT:
            let hasAssignUserGroupsCheckedBoxInSearchResult = false
            return {
                ...state,
                assignUserGroups: {
                    ...state.assignUserGroups,
                    searchResult: action.pagedResult,
                    hasCheckedBoxInSearchResult: hasAssignUserGroupsCheckedBoxInSearchResult
                }
            }
        case types.SHOW_ASSIGN_USER_GROUP_SEARCH_RESULTS:
            return {
                ...state,
                assignUserGroups: {
                    ...state.assignUserGroups,
                    isSubmit: true
                }
            }
        case types.SHOW_ASSIGN_USER_GROUP_TABLE_SEARCH_RESULTS:
            return {
                ...state,
                assignUserGroups: {
                    ...state.assignUserGroups,
                    showSearchResult: action.payload
                }
            }

        case types.GET_USER_GROUPS_END: {
            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    userId: action.payload.userId,
                    userGroups: action.payload.result
                }
            }
        }

        case types.HANDLE_ALL_GROUPS_RADIO_BTN_CHANGE: {
            let { groupId, value } = action.payload;
            // reset toggle value
            const updatedGroups = state.userGroups.groupsMasters/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedGroup = updatedGroups.map((group) => {
                if (group.groupId == groupId) {
                    return { ...group, isChecked: value };
                }
                return group;
            });

            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    groupsMasters: updatedGroup
                }
            };
        }
        case types.RESET_USER_GROUPS: {
            // reset toggle value
            const updatedGroups = state.userGroups.groupsMasters/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedGroup = updatedGroups.map((group) => {
                return { ...group, isChecked: false };
            });

            const updatedUserGroups = state.userGroups.userGroups.map((group) => {
                return { ...group, isChecked: false };
            });

            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    groupsMasters: updatedGroup,
                    userGroups: updatedUserGroups
                }
            };
        }
        case types.MOVE_TO_USER_GROUPS: {
            // reset toggle value
            const groupsToMove = state.userGroups.groupsMasters.filter((group) =>
                group.isChecked == true
            );
            // update current toggle value
            const updatedGroup = groupsToMove.map((group) => {
                return { ...group, isChecked: false };
            });
            const updatedMasterGroup = state.userGroups.groupsMasters.map((group) => {
                return { ...group, isChecked: false };
            });
            const updatedUserGroup = state.userGroups.userGroups.concat(updatedGroup);

            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    groupsMasters: updatedMasterGroup,
                    userGroups: updatedUserGroup
                }
            };
        }
        case types.REMOVE_FROM_USER_GROUPS: {
            // reset toggle value
            const groupCodeToRemove = state.userGroups.userGroups.filter((group) =>
                group.isChecked == false
            );
            const groupToRemove = state.userGroups.groupsMasters.map((group) => {
                if (groupCodeToRemove.includes(group.groupId)) {
                    return { ...group, isChecked: false };
                }
                return group;
            })
            // update current toggle value
            /* const updatedBranch = branchesToMove.map((branch) => {
                return { ...branch, isChecked: false };
            }); */

            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    userGroups: groupCodeToRemove
                }
            };
        }
        case types.HANDLE_USER_GROUPS_RADIO_BTN_CHANGE: {
            let { groupId, value } = action.payload;
            // reset toggle value
            const updatedGroups = state.userGroups.userGroups/*.map((branch) => {
                return { ...branch, isChecked: false };
            })*/;
            // update current toggle value
            const updatedGroup = updatedGroups.map((group) => {
                if (group.groupId == groupId) {
                    return { ...group, isChecked: value };
                }
                return group;
            });

            return {
                ...state,
                userGroups: {
                    ...state.userGroups,
                    userGroups: updatedGroup
                }
            };
        }




        /* case types.RESET_ASSIGN_GROUP_MENUS: {
            const updatedMenus = state.assignGroupMenus.systemMenus
            for (let m in updatedMenus) {
                for (let c in updatedMenus[m].childMenus) {
                    for (let s in updatedMenus[m].childMenus[c].childMenus) {
                        updatedMenus[m].childMenus[c].childMenus[s].isChecked = false;
                    }
                    updatedMenus[m].childMenus[c].isChecked = false;
                }
                updatedMenus[m].isChecked = false;
            }
            return {
                ...state,
                assignGroupMenus: {
                    ...state.assignGroupMenus,
                    systemMenus: updatedMenus
                }
            };
        } */


        case types.GET_SYSTEM_REPORT_END:
            return {
                ...state,
                assignGroupReports: {
                    ...state.assignGroupReports,
                    systemReports: action.payload.result
                }
            }
        case types.RESET_ASSIGN_GROUP_REPORTS: {
            const updatedReports = state.assignGroupReports.systemReports
            for (let m in updatedReports) {
                updatedReports[m].isChecked = false;
            }
            return {
                ...state,
                assignGroupReports: {
                    ...state.assignGroupReports,
                    systemReports: updatedReports
                }
            };
        }

        case types.HANDLE_SYSTEM_REPORT_RADIO_BTN_CHANGE_END: {
            let { reportId, value } = action.payload;
            const updatedReports = state.assignGroupReports.systemReports
            for (let m in updatedReports) {
                if (updatedReports[m].reportId == reportId) {
                    updatedReports[m].isChecked = value;
                }
            }

            return {
                ...state,
                assignGroupReports: {
                    ...state.assignGroupReports,
                    systemReports: updatedReports
                }
            };
        }
        default:
            return state;
    }
}

